import { useLocation } from 'react-router-dom';
import { LANG_CODES, DEFAULT_LANG } from './config';

// Returns the active language code based on the first path segment.
export function getLangFromPath(pathname) {
  const seg = (pathname || '/').split('/')[1];
  return LANG_CODES.includes(seg) && seg !== DEFAULT_LANG ? seg : DEFAULT_LANG;
}

// Removes a language prefix from a path, returning the canonical (English) path.
export function stripLang(pathname) {
  const parts = (pathname || '/').split('/');
  if (LANG_CODES.includes(parts[1]) && parts[1] !== DEFAULT_LANG) {
    parts.splice(1, 1);
    const p = parts.join('/');
    return p === '' ? '/' : p;
  }
  return pathname || '/';
}

// Adds (or swaps) a language prefix on a path.
export function addLang(pathname, lang) {
  const base = stripLang(pathname);
  if (lang === DEFAULT_LANG) return base;
  return base === '/' ? `/${lang}` : `/${lang}${base}`;
}

// Hook returning the active language and a localize() helper for internal links.
export function useLocalizedPath() {
  const { pathname } = useLocation();
  const lang = getLangFromPath(pathname);

  const localize = (path) => {
    if (!path || typeof path !== 'string' || !path.startsWith('/')) return path;
    if (lang === DEFAULT_LANG) return path;
    return path === '/' ? `/${lang}` : `/${lang}${path}`;
  };

  return { lang, localize };
}

export function useLang() {
  const { pathname } = useLocation();
  return getLangFromPath(pathname);
}
